import axios from 'axios';
import { URLS, WEEKDAYS_EN } from '../constants';

// ---------------------------------------------------
// Sources
// ---------------------------------------------------

// todo - maybe add to constants
export const getFrameOrigin = () =>
  process.env.NODE_ENV !== 'production' ? '//www.ceskatelevize.cz' : '';
export const getImgFolder = () =>
  process.env.NODE_ENV !== 'production' ? 'img/' : '/cms/totostoleti/img/';
const backendUrl =
  process.env.NODE_ENV !== 'production'
    ? URLS.BACKEND.DEBUG
    : URLS.BACKEND.PUBLIC;

// ---------------------------------------------------
// Entry
// ---------------------------------------------------

// todo probably move all time stuff sorting/parsing/filtering to backend - but be aware that it's also used by editor

// todo - add reprise parsing?
// todo - quick and dirty
const getTimeData = (times, key, idMonth, idDay) => {
  // todo - maybe just save time id/key?
  // init data
  let entryData = {};
  const timeData = {
    key,
    idYear: 1968,
    idMonth: 0,
    idDay: 0,
    time: '00:00',
    tip: false,
    dayName: ''
  };
  // get entry data
  if (key) {
    entryData = times[key];
    // todo - little bit ugly date parsing
    const dateArray = entryData.date.split('-');
    timeData.idMonth = Number(dateArray[1] - 1);
    timeData.idDay = Number(dateArray[2] - 1);
  } else {
    Object.keys(times).forEach(timeKey => {
      const entry = times[timeKey];
      if (
        entry.date ===
        `1968-${`0${idMonth + 1}`.slice(-2)}-${`0${idDay + 1}`.slice(-2)}`
      ) {
        // todo - bleh - not really prepared for reprise (will be solved on backend by duplicates by date)
        entryData = entry;
        timeData.key = timeKey;
        timeData.idMonth = idMonth;
        timeData.idDay = idDay;
      }
    });
  }

  // parse data
  timeData.time = entryData.time;
  timeData.tip = entryData.tip;
  timeData.dayName = WEEKDAYS_EN[new Date(entryData.date).getDay()];

  // done
  return timeData;
};

const parseEntry = (entry, timeId = null, idMonth = 1, idDay = 1) => {
  // todo - solve month + day ids better way (skipped only for load detail - solved by default)
  const galleryData = getGalleryData(
    entry.programme.data.programme,
    entry.galleryOrder
  );
  const parsedEntry = {
    ...entry,
    timeData: getTimeData(entry.times, timeId, idMonth, idDay),
    isVideo: galleryData.isVideo,
    galleryLength: galleryData.galleryLength
  };
  cacheEntryData(parsedEntry);
  return parsedEntry;
};

export const fetchEntry = (entryId, timeId) =>
  new Promise((resolve, reject) => {
    const entryData = entryDataCache[entryId];
    if (entryData) {
      resolve(entryData);
    } else {
      axios
        .get(`${backendUrl}${URLS.SERVICE.GET_ENTRY}`, {
          params: {
            entryId
          }
        })
        .then(response => {
          if (
            response.data &&
            response.data.state &&
            response.data.state === 'ok'
          ) {
            resolve(parseEntry(response.data.entryData, timeId));
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    }
  });

// ---------------------------------------------------
// Day
// ---------------------------------------------------

const entryDataCache = {};

const cacheEntryData = data => {
  entryDataCache[data.key] = data;
};

const getGalleryData = (programmeData, galleryOrder) => {
  const galleryData = {
    isVideo:
      programmeData &&
      programmeData.videoURL &&
      programmeData.videoURL.indexOf('http') !== -1,
    galleryLength: 0
  };
  // todo - tweak - isVideo - should be true/false no true/undefined
  if (galleryData.isVideo) {
    galleryData.galleryLength += 1;
  }
  galleryData.galleryLength += galleryOrder.length;
  return galleryData;
};

const parseDayData = (dayData, idMonth, idDay) => {
  const parsedData = dayData.map(entry =>
    parseEntry(entry, null, idMonth, idDay)
  );
  parsedData.sort((a, b) => {
    if (a.timeData.time > b.timeData.time) {
      return 1;
    }
    if (a.timeData.time < b.timeData.time) {
      return -1;
    }
    return 0;
  });
  return parsedData;
};

const getTip = dayData => {
  // todo - quick and dirty
  let tip = null;
  for (let i = 0; i < dayData.length; i += 1) {
    if (dayData[i].timeData.tip === true) {
      tip = dayData[i];
    }
  }
  return tip;
};

// todo - skip fetch if day is already loaded/loading
export const fetchDay = (idMonth, idDay) =>
  axios
    .get(`${backendUrl}${URLS.SERVICE.GET_DAY}`, {
      params: {
        idMonth,
        idDay
      }
    })
    .then(response => {
      const parsedData = parseDayData(response.data, idMonth, idDay);
      return {
        data: parsedData,
        tip: getTip(parsedData),
        idMonth,
        idDay
      };
    })
    .catch(error => {
      console.log(error);
      // todo - solve error state
    });

// ---------------------------------------------------
// Hash
// ---------------------------------------------------

let hashInited = false;
let hash = '';

const fetchHash = () => {
  axios
    .get(
      window.location.href.indexOf('specialy') === -1
        ? '/projekt-100-program/player' // todo - probably not needed - only one version/url now
        : '/specialy/totostoleti/program-68/player'
    )
    .then(response => {
      hash = response.data.split('vApp')[1].split('"')[1];
      // repeat in given interval
      setTimeout(() => {
        fetchHash();
      }, 1000 * 60 * 30);
    })
    .catch(error => {
      console.log(error);
      // todo - solve error state
      hash = '2ff0e916016e248d7ea926fec199595af7b4b545';
    });
};

export const initHash = () => {
  if (window.hash) {
    hash = window.hash;
  }
  // todo - review implementation - same in 100
  if (!hashInited) {
    hashInited = true;
    fetchHash();
  }
};

// todo - review implementation - same in 100
export const getHash = () => hash;



// WEBPACK FOOTER //
// ./src/api/index.js